import api from './client'

// COMPRAS — se ejecuta en LGR (Martin, 15 sep 2026).

// Proveedores: maestro de Presea (sync diario) + altas propias de LGR (sin código de Presea).
export const proveedoresApi = {
  listar: (params) => api.get('/proveedores', { params }),
  obtener: (id) => api.get(`/proveedores/${id}`),
  crear: (data) => api.post('/proveedores', data),
}

// Nota de Pedido. El alta lleva `op_uuid` (uno por formulario) para que un
// doble click o un reintento no cree dos pedidos.
export const npApi = {
  listar: (params) => api.get('/compras/np', { params }),
  catalogos: () => api.get('/compras/np/catalogos'),
  codigosProveedor: (proveedor_id, skus) => api.get('/compras/np/codigos-proveedor', { params: { proveedor_id, sku: skus } }),
  // Búsqueda de un artículo por código exacto (codigo_alfa o EAN) en el maestro de LGR.
  buscarArticulos: (q) => api.get('/articulos', { params: { q, activos: true, per_page: 8 } }),
  obtener: (id) => api.get(`/compras/np/${id}`),
  crear: (data) => api.post('/compras/np', data),
  editar: (id, data) => api.put(`/compras/np/${id}`, data),
  emitir: (id) => api.post(`/compras/np/${id}/emitir`),
  nuevaVersion: (id) => api.post(`/compras/np/${id}/nueva-version`),
  // "Cancelación" en el camino de Martin = cancelar el saldo pendiente de renglones.
  cancelarSaldo: (id, data) => api.post(`/compras/np/${id}/cerrar-saldo`, data),
  anular: (id, data) => api.post(`/compras/np/${id}/anular`, data),
  enviar: (id, data) => api.post(`/compras/np/${id}/enviar`, data),
  descargarPdf: async (id, numero) => {
    const { data } = await api.get(`/compras/np/${id}/pdf`, { responseType: 'blob' })
    const url = URL.createObjectURL(data)
    const a = document.createElement('a'); a.href = url; a.download = `nota_pedido_${String(numero || id).replace(/[^\w-]+/g, '_')}.pdf`; a.click()
    URL.revokeObjectURL(url)
  },
}

// Listas de precios de proveedor: se suben y se revisan desde la Nota de Pedido.
export const listasProveedorApi = {
  listar: (proveedorId) => api.get(`/compras/proveedores/${proveedorId}/listas`),
  subir: (proveedorId, archivo, vigenteDesde) => {
    const fd = new FormData()
    fd.append('archivo', archivo)
    if (vigenteDesde) fd.append('vigente_desde', vigenteDesde)
    return api.post(`/compras/proveedores/${proveedorId}/listas`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 600000 })
  },
  obtener: (id) => api.get(`/compras/listas/${id}`),
  aceptarSugerencias: (id, itemIds) => api.post(`/compras/listas/${id}/aceptar-sugerencias`, itemIds ? { item_ids: itemIds } : {}),
  vincular: (id, itemId, articuloId) => api.post(`/compras/listas/${id}/items/${itemId}/vincular`, { articulo_id: articuloId }),
  rechazarSugerencia: (id, itemId) => api.post(`/compras/listas/${id}/items/${itemId}/rechazar-sugerencia`),
  ignorar: (id, itemId, ignorado) => api.post(`/compras/listas/${id}/items/${itemId}/ignorar`, { ignorado }),
  activar: (id) => api.post(`/compras/listas/${id}/activar`),
  descartar: (id) => api.post(`/compras/listas/${id}/descartar`),
  preciosVigentes: (proveedorId, skus) => api.get('/compras/np/precios-proveedor', { params: { proveedor_id: proveedorId, sku: skus } }),
}
